import React, { useEffect, useState } from "react";

import { cloneDeep, uniq } from "lodash";
import styled from "styled-components";
import { isEmpty } from "util/isEmpty";

const AutoComplete = (props) => {
  const [inputValue, setInputValue] = useState("");
  const [filteredOptions, setFilteredOptions] = useState([]);
  const [focusedIndex, setFocusedIndex] = useState(-1);

  const handleInputChange = (e) => {
    const value = e.target.value;
    setInputValue(value);

    const options = props.options;

    const filtered =
      value === ""
        ? options
        : options.filter((option) =>
            option?.toLowerCase().includes(value.toLowerCase())
          );

    const f = cloneDeep(filtered).filter((item) => {
      return item[0] === String(value).toUpperCase();
    });

    if (!arraysEqual(filtered, filteredOptions)) {
      console.log("f", f);
      setFilteredOptions(uniq([...f, ...filtered]));
    }
  };

  const arraysEqual = (arr1, arr2) =>
    arr1.length === arr2.length &&
    arr1.every((value, index) => value === arr2[index]);

  const handleKeyDown = (e) => {
    if (e.key === "ArrowUp") {
      setFocusedIndex((prevIndex) =>
        prevIndex > 0 ? prevIndex - 1 : filteredOptions.length - 1
      );
      setTimeout(() => {
        setInputValue(
          filteredOptions[
            focusedIndex > 0 ? focusedIndex - 1 : filteredOptions.length - 1
          ]
        );
      }, 50);
    } else if (e.key === "ArrowDown") {
      setFocusedIndex((prevIndex) =>
        prevIndex < filteredOptions.length - 1 ? prevIndex + 1 : 0
      );
      setInputValue(
        filteredOptions[
          focusedIndex < filteredOptions.length - 1 ? focusedIndex + 1 : 0
        ]
      );
    } else if (e.key === "Enter") {
      e.preventDefault();
      if (focusedIndex !== -1) {
        setInputValue(filteredOptions[focusedIndex]);
        setFilteredOptions([]);
        setFocusedIndex(-1);
      } else {
        setFilteredOptions([]);
      }
    } else if (e.key === "Escape") {
      setFilteredOptions([]);
    } else if (e.key === "Tab") {
      setFilteredOptions([]);
    }
  };

  useEffect(() => {
    const list = document.getElementById("dropdown-list");
    const selectedItem = document.getElementById(`item-${focusedIndex}`);
    if (list && selectedItem) {
      const itemHeight = selectedItem.offsetHeight;
      const scrollTop = list.scrollTop;
      const offsetTop = selectedItem.offsetTop;
      const listHeight = list.clientHeight;

      if (offsetTop < scrollTop) {
        list.scrollTop = offsetTop;
      } else if (offsetTop + itemHeight > scrollTop + listHeight) {
        list.scrollTop = offsetTop + itemHeight - listHeight;
      }
    }
  }, [focusedIndex, filteredOptions.length]);

  useEffect(() => {
    if (!isEmpty(props.onChange)) {
      props.onChange(inputValue);
    }
  }, [inputValue]);

  useEffect(() => {
    if (props.value) {
      setInputValue(props.value);
    }
  }, [props.value]);

  return (
    <DropDownListWrap className={"liveAutoComplete"}>
      <Input
        type="text"
        value={inputValue}
        onChange={handleInputChange}
        onKeyDown={handleKeyDown}
        placeholder={props.placeholder ? props?.placeholder : "Job title*"}
        required={props?.required !== undefined ? props?.required : true}
        onFocus={handleInputChange}
        className={`${props.formType === true ? "formType" : ""}`}
      />
      {filteredOptions.length > 0 && (
        <DropdownList id="dropdown-list" className={"dropdown-list"}>
          {filteredOptions.map((option, index) => (
            <DropDownItem
              key={option}
              id={`item-${index}`}
              style={{
                background: index === focusedIndex ? "#f8f8f8" : "white",
              }}
              onClick={() => {
                setInputValue(option);
                setFilteredOptions([]);
                setFocusedIndex(-1);
              }}
              onMouseEnter={() => setFocusedIndex(index)}
            >
              <span>{option}</span>
            </DropDownItem>
          ))}
        </DropdownList>
      )}
    </DropDownListWrap>
  );
};

export default AutoComplete;

const DropDownListWrap = styled.div`
  position: relative;
  width: 100%;
`;
const DropdownList = styled.div`
  position: absolute;
  width: 100%;
  z-index: 20;
  border: 1px solid rgb(231, 231, 231);
  max-height: 304px;
  background: #fff;
  overflow-y: auto;
  border-radius: 0 0 4px 4px;
  border-top: 0;

  scrollbar-width: thin;
  scroll-behavior: smooth;
  scrollbar-color: #33333320 transparent;
  &::-webkit-scrollbar {
    width: 3px;
  }
  &::-webkit-scrollbar-thumb {
    background-color: rgba(51, 51, 51, 0.5);
    border: none;
    border-radius: 5px;
  }
  &::-webkit-scrollbar-track {
    background-color: transparent;
    border: none;
  }
`;

const DropDownItem = styled.div`
  padding: 10px 20px;
  border-bottom: 1px solid #e7e7e7;
  font-size: 16px;
  font-family: Arial;
  &:hover {
    background: #f8f8f8;
  }
`;

const Input = styled.input`
  font-family: Arial;
  padding: 21px 16px;
  font-weight: 400;
  font-size: 16px;
  color: #000;
  border: 1px solid #ddd;
  border-radius: 5px;
  display: block;
  width: 100%;
  -webkit-transition: all 0.3s ease-in-out;
  transition: all 0.3s ease-in-out;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;

  &::placeholder {
    color: #999;
  }
  &.warn {
    outline: #ea4335 solid 1px;
  }
  &:focus {
    outline: 1.5px solid #e0c463;
    &.warn {
      outline: #ea4335 solid 1px;
    }
  }
  &.formType {
    width: 100%;
    font-family: Europa-Regular;
    font-size: 16px;
    outline: none;
    border-radius: 8px;
    border: solid 1px #3333334d;
    padding: 12px 16px;
    height: 48px;
    &::placeholder {
      color: #ddd;
    }
  }
`;
